<template>
  <div class="container home">
    <div class="columns">

      <div class="column is-one-third">       

        <user-card></user-card>

        <b-message type="is-info" style="margin-top:16px" has-icon v-if="!authenticated">
            <h6 class="title is-6">Savner du tilgang?</h6>
            <p>Du har ikke mulighet til å registrere bruker selv. Tilgang til rapportløsningen styres av iGive. Dersom du ønsker tilgang eller har andre problemer med å logge på, kontakt oss på <a href="mailto:support@igive.no">support@igive.no</a></p>
        </b-message>

        <b-message type="is-warning" style="margin-top:16px" has-icon v-if="authenticated && passwordChangeRequired">
            <h6 class="title is-6">Sett ditt eget passord</h6>
            <p>Passordet du logger på med er autogenerert av IGive. For din egen trygghet anbefaler vi at du skifter til et eget passord. IGive lagrer ingen passord, og bruker en tredjepartsleverandør (<a href="https://auth0.com" target="_blank">Auth0</a>) for sikrere autentisering og håndtering av brukerdata.</p>
            <br />
            <p>Trykk "Endre passord"-knappen ovenfor for å endre passord.</p>
        </b-message>
        
      </div>

      <div class="column">
        <b-message v-if="showCookiePolicyInfo" class="cookie-policy" type="is-info" has-icon>
            <h6 class="title is-6">Om bruk av informasjonskapsler (cookies)</h6>
            <p>Denne siden benytter informasjonskapsler til å:</p>
            <ul>
              <li>mellomlagre informasjon om pålogget bruker fra autentiseringsleverandøren.</li>
              <li>huske enkelte innstillinger på innloggede sider, for eksempel innstilling for valg av gruppering av rapportdata på 'Rapport'-siden.</li>
            </ul>
            <p>Utover dette er det ingen sporing eller analytiske verktøy som benyttes som kan spore tilbake til bruker av nettsiden</p>
        </b-message>

        <img src="../assets/igive_hjem_header.png" height="80">
      </div>
      
    </div>

    

    
    
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import UserCard from '@/components/UserCard.vue'

export default {
  name: 'home',
  computed: { 
    ...mapGetters('auth', ['authenticated', 'profile', 'showCookiePolicyInfo', 'passwordChangeRequired']), 
  },
  components: {
    UserCard
  },
  created () {
    

    if (this.$route.query && this.$route.query.showLogin) {
      this.$buefy.toast.open({
        duration: 10000,
        message: 'Du må logge på for å komme til denne siden',
        position: 'is-bottom',
        type: 'is-danger'
      })
    }
  }
}
</script>

<style lang="scss">
  div.home {
    margin-top: 32px;
  }

  article.cookie-policy {
    ul {
      padding-left: 32px; 
      margin-top:8px;
      margin-bottom: 8px; 
      list-style: square
    }
  }
</style>

